var map = {
	"./en/translation.json": [
		6013,
		2940
	],
	"./languages.json": [
		95785,
		7350
	],
	"./zh-CN/translation.json": [
		93114,
		3187
	],
	"./zh-rHK/translation.json": [
		6414,
		983
	],
	"./zh-rTW/translation.json": [
		54630,
		1055
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 4125;
module.exports = webpackAsyncContext;